import { render } from "./screen-18.vue?vue&type=template&id=ef23d074&scoped=true"
import script from "./screen-18.vue?vue&type=script&lang=js"
export * from "./screen-18.vue?vue&type=script&lang=js"

import "./screen-18.vue?vue&type=style&index=0&id=ef23d074&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef23d074"]])

export default __exports__